/* eslint-disable max-depth */
/**
 * 设置当前cookie
 * @param cname 需要设置cookie的name
 * @param cvalue 设置的值
 */
export const setCookie = (cname: string, cvalue: string) => {
  document.cookie = `${cname}=${cvalue};path=/;max-age=5184000`;
};

export const setCookieNoTimeout = (cname: string, cvalue: string) => {
  document.cookie = `${cname}=${cvalue};path=/;`;
};

// 增加domain 删除当前cookie
export const deleteCookie = (cname: string) => {
  const domain = getLevel2domain();
  const currentDomain = document.location.hostname;
  document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${currentDomain}`;
  document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain}`;
};

export const setCookieWithDomain = (cname: string, cvalue: string) => {
  const domain = getLevel2domain();
  document.cookie = `${cname}=${cvalue};path=/;max-age=5184000;domain=${domain}`;
};

export const getLevel2domain = () => {
  try {
    let subdomain = '';
    const domain = document.location.hostname;
    const domainList = domain.split('.');

    const ipAddressReg =
      /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
    if (ipAddressReg.test(domain) || domain === 'localhost') {
      let level3domain = document.location.hostname;
      let pattern = /^.*?\b\.\b/;
      return level3domain.replace(pattern, '');
    }

    const urlItems = [];
    urlItems.unshift(domainList.pop());

    while (urlItems.length < 2) {
      urlItems.unshift(domainList.pop());
      subdomain = urlItems.join('.');
    }

    return subdomain || document.location.hostname;
  } catch (e) {
    return document.location.hostname;
  }
};

/**
 * 获取cookie里面的值
 * @param cname 当前cookie name
 * @returns string
 */
export const getCookie = (cname: string) => {
  try {
    let name = `${cname}=`;
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(name) === 0) {
        const res = c.substring(name.length, c.length);
        if (res.length > 0) {
          return decodeURIComponent(res);
        }
      }
    }
    return '';
  } catch (error) {}
  return '';
};
